import axiosInstance from 'api/axiosInstance';
import { CANtrackComment } from 'containers/pages/comments/types/comment';

export const updateComment = async (
	comment: CANtrackComment,
): Promise<void> => {
	const data = {
		payload: {
			id: comment.id,
			TaskTitle: comment.title,
			Description: comment.description,
			CustomerId: comment.customerID,
			CaseId: comment.caseID,
			ActivityID: comment.gpda.activity.id,
			EntryDate: comment.date.toISOString(),
			TimeRegular: comment.timeRegular.toString(),
			TimeOver: comment.timeOver.toString(),
			DeliverableId: comment.gpda.deliverable.id,
			Billable: comment.billable ? 'Y' : 'N',
		},
	};
	try {
		const response = await axiosInstance.post(
			`/api/cantrackv3/UpdateComment`,
			data,
		);
		if (response.status !== 200) {
			throw new Error(
				`Error updating comment: Status ${response.status}`,
			);
		}

		return;
	} catch (error) {
		console.error('updateComment error:', error);
		throw error;
	}
};
